export default {"src":"/_next/static/media/activerpremium.c74d87c3.svg","height":189,"width":277,"blurWidth":0,"blurHeight":0};